import constants from "../../constants/constants";
import React, { useEffect, useState } from 'react'
import { AddRow, DeleteRow, UpArrow, DownArrow, Note } from "../../assets/images/svg/icon"
import { ToPersianNumber, CommaSeparator, DateToPersianNumber } from "../../functions";
import { ErrorToast } from "../../shared";
import ModalInfo from "./reserveInvoice/modalInfo";
import CustomValuesHook from "../../functions/myHooks/CustomValuesHook";
import { getProvince } from "../../api/requestAxios/userInfo";


const PendingToAcceptInvoice = ({
    item,
    data,
    setData,
    lastFactorNumber,
    idOfNewRow,
    setIdOfNewRow,
    setShow,
    setTitle,
    setContent,
    content,
    setRowRejectedInPending,
    setRowReservedInPending,
    setRowBckReservedInPending,
    setIsDeleted,
    isDeleted,
    setIsReserved,
    setIsApprove,
    setviewDetail,
    reservedInPendInvoice,
    rowReservedInPending



}) => {
    const [showModalInfo, setShowModalInfo] = useState(false)
    const [infoModal, setInfoModal] = useState({})
  

    const [infoForm, handleInfoForm] = CustomValuesHook({
        loading: false,
        provinceList: [],
        cityProvince: {},
        cityList: [],
        cityAndProvinceList: [],
        provLoading: false,
        isUpdate: false
    })

    const createCityList = (cityAndProvinceList, provinceCityUser) => {
        if (cityAndProvinceList?.length > 0) {
            let cityListTemp = []

            cityAndProvinceList?.forEach((item, index) => {
                if (item?.Id === provinceCityUser?.provinceId) {
                    let objCity = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id
                    }

                    cityListTemp.push(objCity)
                }
            })
            handleInfoForm({ cityList: cityListTemp })
        }

    }

    const getProv = async (response) => {
        handleInfoForm({ provLoading: true })
        try {
            let preProvince;
            let provinceListTemp = [];
            let cityProvinceTemp = {};

            const listProvinceAndCity = await getProvince()
            listProvinceAndCity?.data?.map((item, index) => {
                //create province list
                if (preProvince !== item.ProvinceName && !item.Delete) {
                    provinceListTemp.push({
                        provinceName: item.ProvinceName,
                        provinceId: item.Id
                    })
                }
                preProvince = item.ProvinceName

                if (item?.CityId === response?.CityIdReservedOrReturned) {
                    cityProvinceTemp = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id,
                        provinceName: item?.ProvinceName
                    }
                }

            })
            handleInfoForm({
                cityAndProvinceList: listProvinceAndCity?.data,
                provinceList: provinceListTemp,
                cityProvince: cityProvinceTemp,
                provLoading: false
            })
            createCityList(listProvinceAndCity?.data, cityProvinceTemp)

        }
        catch (error) {
            handleInfoForm({
                provLoading: false
            })
            ErrorToast(error)
        }
    }

    //***************************************************************************** */
    const rejectFactorFn = (e) => {
        e.preventDefault()
        setIsDeleted(true)
        setIsReserved(false)
        setIsApprove(false)

        setContent('')
        setShow(true)
        setTitle(constants.RejectInvoiceReason)
        setRowRejectedInPending(item.idTable)
    }
    //***************************************************************************** */
    const addRowFn = (e) => {
        e.preventDefault()
        setIsReserved(true)
        setIsDeleted(false)
        setIsApprove(false)
        setShowModalInfo(true)
        getProv()
        setRowReservedInPending(item.idTable)
        handleInfoForm({ isUpdate: false })
    }
    //***************************************************************************** */
    const deleteRowFn = (e) => {
        setIdOfNewRow('')
        setRowBckReservedInPending(item.idTable)
    }
    //***************************************************************************** */
    const viewDesciption = () => {
        if (item.StatusEn === 'deleteRow') {
            setShow(true)
            setContent(item.DescriptionReservedOrReturned)
            setTitle(constants.RejectInvoiceReason)
            setviewDetail(true)
        }
        else {
            setInfoModal(data?.data[item?.idTable])
            getProv(data?.data[item?.idTable])
            setShowModalInfo(true)
            handleInfoForm({ isUpdate: true })
        }

    }
    //**************************************************************************** */
    return (
        <>
            <div className='d-flex flex-row justify-content-end ' >
                {(item.StatusEn === 'ReservedInPending' || item.StatusEn === 'deleteRow') && <span className="view-description-icon" onClick={viewDesciption}><Note /></span>}
                {item.StatusEn === 'PendingToAccept' && <button onClick={(e) => { rejectFactorFn(e) }} className="btn-invoice reject" >{constants.Reject}</button>}
                {item.StatusEn === 'addNewRow' ? <span onClick={(e) => { deleteRowFn(e) }}>< DeleteRow /></span> : item.StatusEn !== 'deleteRow' && item.StatusEn !== 'ReservedInPending' ? <span onClick={(e) => { addRowFn(e) }}>{<AddRow />}{item?.OfficialFactorType}</span> : ''}
            </div>
            {showModalInfo && <ModalInfo
                fromPage="pending"
                showModalInfo={showModalInfo}
                setShowModalInfo={setShowModalInfo}
                officialFactorId={item?.OfficialFactorId}
                reservedInPendInvoice={reservedInPendInvoice}
                createCityList={createCityList}
                infoForm={infoForm}
                handleInfoForm={handleInfoForm}
                item={item}
                infoModal={infoModal}
                setIsReserved={setIsReserved}

            />}
        </>

    )
}
export default PendingToAcceptInvoice
